import { query } from "../_generated/server";
import { v } from "convex/values";

export const getWritingStyles = query({
  args: {},
  handler: async (ctx) => {
    const identity = await ctx.auth.getUserIdentity();
    if (!identity) {
      throw new Error("Unauthenticated");
    }

    return await ctx.db
      .query("writingStyles")
      .withIndex("by_userId", (q) => q.eq("userId", identity.subject))
      .collect();
  },
});